import Loadable from "react-loadable";

const LazyExperts = Loadable({
  loader: () => import(/* webpackChunkName: 'consultants-externe' */ "./index"),
  loading: () => 'loading...'
});

export default LazyExperts;
